import { atom, useRecoilState } from "recoil";

const pageObject = atom<{current: number, total: number, readerYRange: [number, number]}>({
    key: "pageObject",
    default: {
        current: 0,
        total: 0,
        readerYRange: [0,0],
    }
});

export const useReaderSize = () => {

    const [page, setPage] = useRecoilState(pageObject);

    return {
        page, setPage,
    };
}